var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner",style:({
    backgroundColor: _vm.config.backgroundColor,
    color: 'var(--tokens-text)',
  })},[_c('KIcon',{staticClass:"icon",attrs:{"icon":_vm.config.icon,"color":_vm.config.iconColor}}),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }